export function preloadVideo(src: string): Promise<unknown> {
  return new Promise((resolve, reject) => {
    const video = getElement('video');

    video.onloadeddata = () => {
      cleanUpElement(video);
      resolve(null);
    };

    video.onerror = (error: any) => {
      cleanUpElement(video);
      reject(error);
    };

    video.setAttribute('src', src);

    // Safari fix: apparently we need to append the video element to the DOM
    // in order for the events to fire properly.
    document.body.appendChild(video);
  });
}

export function getElement(tagName: string): HTMLElement {
  const element = document.getElementById('element-preloader');
  if (element) document.body.removeChild(element);

  const newElement = document.createElement(tagName);
  newElement.setAttribute('id', 'element-preloader');
  newElement.setAttribute('style', 'display: none');

  return newElement;
}

export function cleanUpElement(element: HTMLElement): void {
  document.body.removeChild(element);
}
